module.exports = __webpack_public_path__ + "static/media/step-ladders@3x.39a8ec9b.png";